import { createContext } from 'react';

/**
 *
 * @returns {다국어 데이터 모음 컨텍스트}
 */

type Lang = {
  code: string;
  code_name: string;
  comment: string;
}[];
const LocalizingContext = createContext<Lang | undefined>([
  { code: 'KO', code_name: '한국어', comment: '' },
  { code: 'EN', code_name: '영어', comment: '' },
  { code: 'JA', code_name: '일본어', comment: '' },
  { code: 'AR', code_name: '아랍어', comment: '' },
  // { code: 'SC', code_name: '중국어 간체', comment: '' },
]);

export default LocalizingContext;
